import { reportError } from "./bugReporting";

// https://devblogs.microsoft.com/typescript/announcing-typescript-3-7/#assertion-functions
export function assertIsDefined<T>(val: T): asserts val is NonNullable<T> {
  if (val === undefined || val === null) {
    reportError(new Error(`Expected 'val' to be defined, but received ${val}`)); // Report to Sentry
    throw new Error(`Expected 'val' to be defined, but received ${val}`);
  }
}
